import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AbstractActionService} from '../../../../../core/service/v2/service/action/abstractAction.service';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';
import {PurchaseOrderSendByEmailPayload} from './payload/purchaseOrderSendByEmail.payload';

@Injectable()
export class PurchaseOrderSendByEmailActionService extends AbstractActionService<PurchaseOrderSendByEmailPayload, any> {
    public constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                       httpClient: HttpClient) {
        super('PurchaseOrder', 'send', customizeHttpUrlGenerator, httpClient);
    }
}
